import React from 'react';
import classnames from 'classnames';
import { default as Icon } from '../../../images/icon/24-1_commentdots.svg';
import SVG from 'react-inlinesvg';

type IconProps = {
  className?: string;
};
const CommentDots: React.FC<IconProps> = props => <SVG src={Icon} className={classnames(props.className, 'icon')} />;
export default CommentDots;
